import { combineReducers } from "redux";
import { Gateway } from "../../types";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { FETCH_PAYMENT_GATEWAYS_REQUEST, UPDATE_PAYMENT_GATEWAY_REQUEST } from "./constants";
import { Action } from "./types";

function items(state: Gateway[] = [], action: Action): Gateway[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_PAYMENT_GATEWAYS_REQUEST):
      return action.payload;

    case getSuccessActionType(UPDATE_PAYMENT_GATEWAY_REQUEST):
      return state.map((payment) => (payment.id === action.data.paymentId ? action.payload : payment));

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_PAYMENT_GATEWAYS_REQUEST:
    case UPDATE_PAYMENT_GATEWAY_REQUEST:
      return true;

    case getSuccessActionType(FETCH_PAYMENT_GATEWAYS_REQUEST):
    case getFailureActionType(FETCH_PAYMENT_GATEWAYS_REQUEST):
    case getSuccessActionType(UPDATE_PAYMENT_GATEWAY_REQUEST):
    case getFailureActionType(UPDATE_PAYMENT_GATEWAY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const paymentGateways = combineReducers({ items, isFetching });
